import React from 'react';
import { Box, Button, Flex, Heading, Stack, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { Bank, Upload } from 'phosphor-react';

import { GlassCard } from '../../../../../components/glass';

interface EmptyStateProps {
  onImportar?: () => void;
}

export const EmptyState = ({ onImportar }: EmptyStateProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      <GlassCard intensity="strong" p={{ base: 8, md: 12 }} textAlign="center">
        <Stack align="center" spacing={6} maxW="520px" mx="auto">
          <motion.div
            animate={{ y: [0, -6, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
            style={{ transformStyle: 'preserve-3d' }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              w="88px"
              h="88px"
              borderRadius="3xl"
              bg="linear-gradient(135deg, #E0E7FF 0%, #DDD6FE 100%)"
              boxShadow="0 18px 40px -8px rgba(99, 102, 241, 0.32), inset 0 1px 0 rgba(255,255,255,0.6)"
              transform="perspective(600px) rotateX(10deg)"
              color="#6366F1"
            >
              <Bank size={44} weight="duotone" />
            </Box>
          </motion.div>

          <Box>
            <Heading
              as="h2"
              fontSize={{ base: 'xl', md: '2xl' }}
              fontWeight="700"
              color="#0F172A"
              letterSpacing="-0.02em"
              mb={2}
            >
              Comece importando o primeiro extrato
            </Heading>
            <Text fontSize="sm" color="#64748B" lineHeight="1.6">
              A Conciliação Contábil categoriza automaticamente seus lançamentos bancários, vincula
              ao Plano de Contas e gera o TXT pronto para o Domínio.
            </Text>
          </Box>

          <Flex gap={3} wrap="wrap" justify="center">
            <Button
              leftIcon={<Upload size={18} weight="bold" />}
              bg="#1B88F5"
              color="white"
              _hover={{ bg: '#0E5FB8', transform: 'translateY(-1px)' }}
              _active={{ bg: '#0E5FB8' }}
              fontSize="sm"
              fontWeight="600"
              borderRadius="full"
              px={6}
              py={5}
              boxShadow="0 8px 20px -4px rgba(27, 136, 245, 0.42)"
              onClick={onImportar}
              isDisabled={!onImportar}
            >
              Importar primeiro extrato
            </Button>
          </Flex>

          <Text fontSize="11px" color="#94A3B8">
            Suportamos PDF, OFX, XLSX e ZIP de 13+ bancos brasileiros
          </Text>
        </Stack>
      </GlassCard>
    </motion.div>
  );
};
